import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
} from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import { getFillAllFieldError } from "../../../Constant/Message";
import { FileInputField, InputField } from "../../../CommonElements";
import createSKDokumen from "../services/CreateSKDokumen";

function ModalUploadDokumen({ modal, toggle, getSKDokumen }) {
  const axiosInstance = useAxios();

  const [waitingForSubmit, setWaitingForSubmit] = useState(false);
  const [formData, setFormData] = useState({
    judul: "",
    deskripsi: "",
    dokumen: null,
  });

  const handleChange = (e) => {
    if (e === null) {
      return;
    }

    const { name, value, files } = e.target;

    if (name === "dokumen") {
      setFormData((prevState) => ({
        ...prevState,
        ["dokumen"]: files[0],
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      formData.judul === "" ||
      formData.deskripsi === "" ||
      formData.dokumen === null
    ) {
      toast.error(getFillAllFieldError(), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      return;
    }

    setWaitingForSubmit(true);
    createSKDokumen(axiosInstance, formData).then((response) => {
      setWaitingForSubmit(false);
      getSKDokumen();
      toggle();
    }).catch(() => {
        setWaitingForSubmit(false);
    });
  };

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
      <ModalHeader toggle={toggle}>Upload Dokumen</ModalHeader>
      <ModalBody>
        <Form>
          <InputField
            label={"Judul"}
            name={"judul"}
            onChange={(e) => handleChange(e)}
          />
          <InputField
            label={"Deskripsi"}
            name={"deskripsi"}
            onChange={(e) => handleChange(e)}
          />
          <FileInputField
            label={"Upload Dokumen"}
            name={"dokumen"}
            onChange={(e) => handleChange(e)}
          />
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={waitingForSubmit}
        >
          Submit
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalUploadDokumen;
